/** Shared "Show more" button for the report footers. Disabled + relabelled while the next page loads. */
export function ShowMoreButton({ onClick, loading }: { onClick: () => void; loading: boolean }) {
  return (
    <div className="mt-2 flex justify-center">
      <button
        type="button"
        onClick={onClick}
        disabled={loading}
        aria-busy={loading}
        className="rounded-lg border border-slate-900/10 bg-white px-3 py-1.5 text-[12px] font-semibold hover:bg-slate-100 disabled:opacity-60"
      >
        {loading ? 'Loading…' : 'Show more'}
      </button>
    </div>
  )
}
